import { render, staticRenderFns } from "./IpUtils.vue?vue&type=template&id=3671d1fd&scoped=true"
import script from "./IpUtils.vue?vue&type=script&lang=js"
export * from "./IpUtils.vue?vue&type=script&lang=js"
import style0 from "./IpUtils.vue?vue&type=style&index=0&id=3671d1fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671d1fd",
  null
  
)

export default component.exports